import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { firstLetterShouldCapital, capitalizeWords,formatDateMoment,convertToUpperCase } from "../../../../utils/utils";
import { useSelector } from "react-redux";
import { selectCurrentCycle,selectFollowCycle } from "../../../slices/common";

const QrPrintContent = React.forwardRef(({isVisible=false, printData }, ref) => {
  const {
    printPatientInfo,
    bagCount = 0,
    printCount = 1,
    printSingleBag,
    patientMedicalInfo = {},
  } = printData || {};
  const patientInfo = printPatientInfo?.patient_information || {};
  const patientName = patientInfo?.name || "";
  const currentCycle = isVisible ? useSelector(selectFollowCycle) : useSelector(selectCurrentCycle)
  const qrValue = `${window.location.origin}/lsm/qr/${currentCycle?.qr_code_generation_id}`;
  const topLevel = patientInfo?.print_details?.find((it) => it?.label_type == '5')
  const rightLogo = topLevel?.org_logo;
  const leftLogo = topLevel?.brand_logo;
  const brand_name = topLevel?.brand_name;
  const org_name = topLevel?.org_name;
  return (
    <div ref={ref} className="font-sans">
      {Array.from({ length: printCount }).map((_, index) => (
        <div
          key={index}
          style={{
            width: "142mm",
            height: "142mm",
            border: "1px solid #000",
            boxSizing: "border-box",
            pageBreakAfter: "always",
           // padding: "0.6cm",
            padding: "0.2cm 0.6cm",
            fontSize: "10px",
            display: "flex",
            flexDirection: "column",
            borderRadius:"5px"
          }}
        >

          <div className="flex items-center justify-between mb-1">

            <div className="flex items-center gap-2">
              <img
                src={leftLogo}
                style={{maxHeight:'50px', maxWidth:'100px'}}
                alt="left-logo"
                className="object-contain"
              />
             {/* <span className="text-sm">ImmunoACT</span>*/}
            </div>

            <div className="flex-1 text-center">
              <div className="text-lg font-bold tracking-wide">
             {brand_name ?? '--'}
              </div>
              <div className="text-base mt-1">
                {org_name ?? '--'}
              </div>
            </div>

            <div className="flex items-center">
              <img
                src={rightLogo}
                style={{maxHeight:'50px', maxWidth:'100px'}}
                alt="right-logo"
                className="object-contain"
              />
            </div>
          </div>
<div className="-mx-[0.6cm] my-[0.1cm] border-t-2 border-black" />

          <div className="flex justify-between items-start gap-4">

            <div className="text-base leading-relaxed space-y-2.5">

              <p><span className="font-bold">Patient Name: </span><span className="font-semibold">{capitalizeWords(patientInfo.name)}</span>
</p>
              <p><span className="font-bold">Patient Initials: </span><span className="font-semibold">
                  {firstLetterShouldCapital(convertToUpperCase(patientName))}
                </span></p>
              <p><span className="font-bold">Patient Body Weight (kg): </span> <span className="font-semibold">
                  {patientInfo.body_weight}
                </span></p>
               <p><span className="font-bold">Patient Weight Submitted: </span><span className="font-semibold">{formatDateMoment(printPatientInfo.created_at)}</span></p>
                <p><span className="font-bold">Disease Indication: </span><span className="font-semibold">{capitalizeWords(patientInfo.disease)}</span></p>
              <p><span className="font-bold">Date of Birth: </span><span className="font-semibold">
                  {patientMedicalInfo["Date of Birth"]}
                </span></p>
              <p><span className="font-bold">Hospital Name: </span><span className="font-semibold">{patientInfo.hospital}</span>
</p>
              <p><span className="font-bold">Hospital Patient ID: </span><span className="font-semibold">{printPatientInfo.hospital_patient_id}</span>
</p>
              <p><span className="font-bold">ImmunoACT Patient ID: </span><span className="font-semibold">
                  {patientInfo.immunoact_patient_id}
                </span></p>

              <p>
                <span className="font-bold">Ship and Store at: </span>
                {patientMedicalInfo["Ship & Store"]}
              </p>

              <p>
                <span className="font-bold">Bag no: </span>
                <span className="font-semibold inline-block min-w-[80px] border-b border-black">
                  {printSingleBag ? printSingleBag : bagCount + index + 1}
                </span>
              </p>

            </div>

            <div className="flex flex-col items-center justify-start w-[110px]">

              <div className="mt-8 ml-[-16px]">
                <QRCodeCanvas value={qrValue} size={150} />
              </div>

            </div>

          </div>

        </div>
      ))}
    </div>
  );
});

export default QrPrintContent;
